import { isEmpty, isNullOrUndef } from "utils";

/**
 * Checks if a value is null, undefined, or an empty string.
 *
 * Note that this is a type guard that narrows the type.
 *
 * @param {unknown} value - value to check
 * @returns {value is null | undefined | ''} - true if value is null, undefined or empty string.
 */
export default function isNullOrUndefOrEmpty(value) {
  return isEmpty(value) || isNullOrUndef(value);
}
